// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';

import ToastActions from 'actions/ToastActions.js';

import GENERATE_SFTP_CREDS_MUTATION from './queries/GenerateSftpCredentialsMutation.gql';

type Props = {
  children: Function,
  orgUuid: string,
  onCredentialGeneration: () => void,
  mutate: ({
    variables: {
      input: GenerateAutoMessageSftpCredentialsInput,
    },
  }) => Promise<*>,
};

type State = {
  credentials: ?{
    username: string,
    password: string,
  },
};

class AdminNewAutoMessageSftpCredentialsFormContainer extends React.Component<Props, State> {
  state = {
    credentials: undefined,
  };

  handleCredentialGeneration = (name: ?string) => {
    if (!name) {
      console.error(
        'AdminNewAutoMessageSftpCredentials - tried to generateAutoMessageSftpCredentials without a name'
      );
      return;
    }

    const { orgUuid } = this.props;
    this.props.mutate({ variables: { input: { name, orgUuid } } }).then(
      res => {
        const { credentials, error } = res.data.generateAutoMessageSftpCredentials;
        if (error) {
          console.warn(error);
          console.error(
            'AdminNewAutoMessageSftpCredentials - generateAutoMessageSftpCredentials failure'
          );
          ToastActions.showAPIError(error);
        }

        if (credentials) {
          this.setState({
            credentials: credentials.credentials,
          });
          this.props.onCredentialGeneration();
        }
      },
      err => {
        console.warn(err);
        console.error(
          'AdminNewAutoMessageSftpCredentials - generateAutoMessageSftpCredentials failure'
        );
        ToastActions.showAPIError(err);
      }
    );
  };

  render() {
    const { credentials } = this.state;
    return this.props.children({
      credentials,
      onCredentialGeneration: this.handleCredentialGeneration,
    });
  }
}

const withGenerateMutation = graphql(GENERATE_SFTP_CREDS_MUTATION);

export { AdminNewAutoMessageSftpCredentialsFormContainer };

export default withGenerateMutation(AdminNewAutoMessageSftpCredentialsFormContainer);
